import { render } from "./OnlineAllCanvas.vue?vue&type=template&id=2990a8e9"
import script from "./OnlineAllCanvas.vue?vue&type=script&lang=js"
export * from "./OnlineAllCanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__